const groups = [
  {
    title: "阅读入口",
    links: [
      { id: "chapters", label: "章节列表" },
      { id: "feed", label: "更新快讯" },
      { id: "collections", label: "故事合集" },
    ],
  },
  {
    title: "收听与榜单",
    links: [
      { id: "audiobook", label: "有声书" },
      { id: "ranking", label: "热度榜" },
      { id: "top", label: "返回顶部" },
    ],
  },
];

export default function SiteFooter() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full bg-secondary-900">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr] md:gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-book-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                善良的女秘书
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-background-300">
              一个为秘书题材小说爱好者整理的故事资源页，收录小说全文、未删减版、有声书与故事合集，让阅读和收听都更顺手。
            </p>
          </div>

          {groups.map((g) => (
            <div key={g.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">{g.title}</h3>
              <ul className="mt-4 space-y-3">
                {g.links.map((l) => (
                  <li key={l.id}>
                    <button
                      type="button"
                      onClick={() => goTo(l.id)}
                      className="text-sm font-label text-background-300 transition-colors hover:text-accent-400"
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs font-label text-background-400">
            © 2026 善良的女秘书 · 故事资源聚合页
          </p>
          <p className="text-xs font-label text-background-400">
            页面内容仅作阅读导航之用 · 请支持正版阅读
          </p>
        </div>
      </div>
    </footer>
  );
}